import React, { useState, useEffect } from 'react';
import env from '../../utils/env';
import Header from '../../components/common/header/Header';

function MySubscriptionsPage() {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [cancellingId, setCancellingId] = useState(null);

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const fetchSubscriptions = async () => {
    try {
      const userDetails = localStorage.getItem('userDetails');
      const token = localStorage.getItem('token');

      if (!userDetails || !token) {
        setError('User details or token not found');
        setLoading(false);
        return;
      }

      const userData = JSON.parse(userDetails);
      const email = userData?.email;

      if (!email) {
        setError('Email not found in user details');
        setLoading(false);
        return;
      }

      const response = await fetch(
        `${env.REACT_APP_API_URL}/interview-app/purchaseplan/getsubscriptions?email=${encodeURIComponent(email)}`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      const data = await response.json();

      if (data.status && data.result) {
        setSubscriptions(data.result);
      } else {
        setError(data.message || 'Failed to fetch subscriptions');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const cancelSubscription = async (subscriptionId) => {
    setError(null);
    setSuccessMessage('');
    setCancellingId(subscriptionId);

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('Token not found');
        return;
      }

      const response = await fetch(
        `${env.REACT_APP_API_URL}/interview-app/purchaseplan/cancelsubscription?subscription_id=${subscriptionId}`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: '',
        }
      );

      const data = await response.json();
      if (data.status) {
        setSuccessMessage(data.message || 'Subscription canceled successfully.');
        setSubscriptions((prev) => prev.filter((sub) => sub.id !== subscriptionId));
      } else {
        setError(data.message || 'Failed to cancel subscription');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setCancellingId(null);
    }
  };

  return (
    <>
      <Header />
      <div style={{ padding: '20px', marginTop: '80px' }}>
        <h1>My Subscriptions</h1>
      
      {error && (
        <div style={{ color: 'red', marginBottom: '20px' }}>
          Error: {error}
        </div>
      )}

      {successMessage && (
        <div style={{ color: 'green', marginBottom: '20px' }}>
          {successMessage}
        </div>
      )}

      {subscriptions.length === 0 ? (
        <p>No active subscriptions found.</p>
      ) : (
        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
          <thead>
            <tr style={{ backgroundColor: 'lightblue' }}>
              <th style={{ border: '1px solid #ddd', padding: '12px', textAlign: 'left' }}>Subscription ID</th>
              <th style={{ border: '1px solid #ddd', padding: '12px', textAlign: 'left' }}>Plan Name</th>
              <th style={{ border: '1px solid #ddd', padding: '12px', textAlign: 'left' }}>Start Date</th>
              <th style={{ border: '1px solid #ddd', padding: '12px', textAlign: 'left' }}>End Date</th>
              <th style={{ border: '1px solid #ddd', padding: '12px', textAlign: 'left' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {subscriptions.map((sub, index) => (
              <tr key={index}>
                <td style={{ border: '1px solid #ddd', padding: '12px' }}>{sub.id}</td>
                <td style={{ border: '1px solid #ddd', padding: '12px' }}>{sub.plan_name}</td>
                <td style={{ border: '1px solid #ddd', padding: '12px' }}>{sub.start_date}</td>
                <td style={{ border: '1px solid #ddd', padding: '12px' }}>{sub.current_period_end}</td>
                <td style={{ border: '1px solid #ddd', padding: '12px' }}>
                  <button
                    style={{
                      backgroundColor: '#ff4d4f',
                      color: 'white',
                      border: 'none',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      cursor: cancellingId === sub.id ? 'not-allowed' : 'pointer',
                    }}
                    disabled={cancellingId === sub.id}
                    onClick={() => cancelSubscription(sub.id)}
                  >
                    {cancellingId === sub.id ? 'Cancelling...' : 'Cancel'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      </div>
    </>
  );
}

export default MySubscriptionsPage;